import { RunType } from "types/generated";
import { makeEnumEqualsPredicate, makeStringEqualsPredicate } from "utils/predicates";

export const makeStackTasksPredicates = (stackId: string) => [
  makeStringEqualsPredicate("stackSlug", [stackId]),
  makeEnumEqualsPredicate("type", [RunType.Task]),
];
